<template>
	<el-drawer title="回聊详情" :size="'60%'" :visible.sync="drawer" direction="rtl" :before-close="handleClose">
		<div style="padding: 10px;">
			<chatView :isChatingId="isChatingId" :nickname="nickname" :groupIndex="groupIndex"
				:specificChatMessage="specificChatMessage" :scrollType="scrollType" @send="comSend" height="100%"
				width="100%" :chatid="chatid" :index="index" :opt="opt" :row="row" @deleteChating="deleteChating"
				:scrollHeight="scrollHeight" @clearRead="clearRead" @spliceBuyWait="spliceBuyWait" :page="page"
				@addPage="addPage" :isShowInput="false" />
		</div>
	</el-drawer>
</template>

<script>
	import chatView from '@/components/chatView'
	export default {
		name: 'rightDrawer',
		components: {
			chatView,
		},
		props: {
			drawer: {
				type: Boolean,
				default: false,
			},
			params: {
				type: Object,
				default: () => {}
			}
		},
		data() {
			return {
				chatid: '',
				index: 0,
				opt: false,
				row: {},
				message_num: 10,
				isChatingId: '',
				page: 1,
			}
		},
		watch: {
			drawer: {
				handler(val) {
					if(val){
						this.initChatAfterWsReady()
					}
				},
				immediate: true
			},
		},
		mounted() {
			// this.initChatAfterWsReady()
		},
		methods: {
			initChatAfterWsReady() {
				// 避免重复
				if (this.chatid === this.isChatingId && this.opt) return

				this.opt = true
				this.chatid = this.params.session_id
				this.row = this.params
				this.isChatingId = this.params.session_id

				this.page = 1
				this.$store.commit('kefu/SET_MESSAGE_LIST', [])
				this.message_num = 10
				this.scrollHeight = 0

				// 如果这里要拉历史消息 / send
				// 一定是 wsReady === true
			},
			handleClose(done) {
				this.$confirm('确认关闭？')
					.then(() => {
						// this.$refs.initConnectChatRef.closeWebSocket()
						this.$emit('update:drawer', false)
						done();
					})
					.catch(() => {});
			},
			addPage() {
				this.page++;
				let ChatingData = {
					identify: 'customer_service',
					type: 'message_list',
					session_id: this.isChatingId,
					data: {
						page: this.page,
						per_page: this.per_page,
						last_id: this.last_id
					}
				}
				this.$kefuSocket.send(ChatingData);
			},
		}
	}
</script>

<style>
</style>